import { ClientSettingsContext } from "@contexts/ClientSettings";
import { useContext } from "react";

export const useClientSettings = () => useContext(ClientSettingsContext);
export const useClientApiKeys = () => useClientSettings().apiKeys;
